import { useMemo, useState } from "react"

import { Layout, Segmented } from "antd"
import { useSelector } from "react-redux"
import { Outlet, useLocation } from "react-router-dom"

import { usePhoneCountries } from "../../hooks/usePhoneCountries"
import { useSkippedStepRedirect } from "../../hooks/useSkippedStepRedirect"
import Icon from "../../Icon"
import { subStepsStorage } from "../../Utils/onboarding/setStatusSubSteps"
import QuickLinkItem from "../GettingStartedPage/componets/QuickLinkItem"
import OnboardingDots from "./components/OnboardingDots"
import OnboardingHeader from "./components/OnboardingHeader"
import SideBar from "./components/SideBar"
import { getQuickList } from "./utils/helpers/getQuickList"

import "./styles.less"

const { Content } = Layout

const OnboardingLayout = () => {
  usePhoneCountries()
  useSkippedStepRedirect()
  const [showSubSteps, setShowSubSteps] = useState(subStepsStorage.get() || null)
  const [mobileTab, setMobileTab] = useState("overview")
  // useOnboardingStepGuard();
  const isMobile = useSelector((state) => state.nav.isMobile)

  const { pathname } = useLocation()
  const segments = pathname.split("/")
  const path = segments[2] ?? ""
  const quickList = useMemo(() => getQuickList(`/${path}`), [path])

  return (
    <Layout className="ob-wrap">
      <OnboardingHeader isMobile={isMobile} />
      {isMobile && (
        <div className="ob-dots-mobile">
          <OnboardingDots />
        </div>
      )}
      {isMobile && (
        <div className="ob-mobile-tabs">
          <Segmented
            block
            options={[
              { label: "Overview", value: "overview" },
              { label: "Quick links", value: "quickLinks" }
            ]}
            value={mobileTab}
            onChange={setMobileTab}
          />
        </div>
      )}

      <Layout className="ob-body">
        {!isMobile && <SideBar showSubSteps={showSubSteps} />}
        <Content className="ob-content">
          {isMobile && mobileTab === "quickLinks" ? (
            <div className="ob-mobile-quick-links">
              {quickList.map((i) => (
                <QuickLinkItem
                  key={i.title}
                  icon={<Icon type={i.icon} />}
                  title={i.title}
                  description={i.description}
                  url={i.url}
                  isRecommend={i.recommended}
                />
              ))}
            </div>
          ) : (
            <div className="ob-card">
              <Outlet context={{ setShowSubSteps }} />
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  )
}

export default OnboardingLayout
